module.exports = __webpack_public_path__ + "static/media/sun-beams.3414d2f3.svg";